import dicomParser from 'dicom-parser';
import cornerstone from 'cornerstone-core';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import cornerstoneMath from 'cornerstone-math';
import cornerstoneTools from 'cornerstone-tools';
import Hammer from 'hammerjs';
import { cornerstone as ohifCornerstone } from '@ohif/core';
import MagnifyPlusTool from '../customTools/MagnifyPlusTool';
import OverlayTool from '../customTools/OverlayTool';
import MoveFrameTool from '../customTools/MoveFrameTool';
import { addSubdirectoryToPath } from './getConfig';
import wadoRSLoadImage from '../../loaders/mywadors/loadImage';
import { loadImage as wadoURILoadImage } from '../../loaders/mywadouri/loadImage';

export function initCornerstone(appConfig) {

  window.cornerstone = cornerstone;
  window.cornerstoneTools = cornerstoneTools;
  window.cornerstoneWADOImageLoader = cornerstoneWADOImageLoader;

  cornerstoneTools.MagnifyPlusTool = MagnifyPlusTool;
  cornerstoneTools.OverlayTool = OverlayTool;
  cornerstoneTools.MoveFrameTool = MoveFrameTool;

  const { metadataProvider } = ohifCornerstone;
  cornerstone.metaData.addProvider(metadataProvider.get.bind(metadataProvider));

  cornerstoneTools.external.cornerstone = cornerstone;
  cornerstoneTools.external.Hammer = Hammer;
  cornerstoneTools.external.cornerstoneMath = cornerstoneMath;

  if (appConfig.authorizationHeader) {
    cornerstoneWADOImageLoader.configure({
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', appConfig.authorizationHeader);
      },
    });
  }

  cornerstoneTools.init({
    showSVGCursors: true,
    touchEnabled: true,
    globalToolSyncEnabled: true, // testing what is it?
    autoResizeViewports: true,
    lineDash: [4, 4],
  });

  // testing this
  cornerstoneTools.loadHandlerManager.setErrorLoadingHandler((element, imageId, error) => {
    log.error(imageId);
    throw error;
  });

  // Preferences
  const fontFamily = 'Work Sans, Roboto, OpenSans, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif';
  cornerstoneTools.textStyle.setFont(`16px ${fontFamily}`);
  cornerstoneTools.toolStyle.setToolWidth(2);
  cornerstoneTools.toolColors.setToolColor('rgb(158, 224, 78)'); // 9ee04e
  cornerstoneTools.toolColors.setActiveColor('rgb(126, 179, 62)'); // 7eb33e

  cornerstoneTools.store.state.touchProximity = 40;

  // Configure stack prefetch
  cornerstoneTools.stackPrefetch.setConfiguration({
    maxImagesToPrefetch: Infinity,
    preserveExistingPool: false,
    maxSimultaneousRequests: 20,
  });

  // IMAGE LOADER
  cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
  cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
  cornerstoneWebImageLoader.external.cornerstone = cornerstone;

  // register the url scheme 'myCustomLoader' with our loadImage function
  cornerstone.registerImageLoader('mywadors', wadoRSLoadImage);
  cornerstone.registerImageLoader('mywadouri', wadoURILoadImage);

  const origin = window.location.origin;

  const config = {
    maxWebWorkers: navigator.hardwareConcurrency || 1,
    startWebWorkersOnDemand: false,
    webWorkerPath: '/workers/cornerstoneWADOImageLoaderWebWorker.min.js',
    // webWorkerTaskPaths: ['https://unpkg.com/cornerstone-wado-image-loader@4.1.0/dist/610.bundle.min.worker.js', 'https://unpkg.com/cornerstone-wado-image-loader@4.1.0/dist/888.bundle.min.worker.js'],
    webWorkerTaskPaths: [`${origin}${addSubdirectoryToPath('/meta/610.js')}`, `${origin}${addSubdirectoryToPath('/meta/888.js')}`],
    taskConfiguration: {
      decodeTask: {
        loadCodecsOnStartup: true,
        initializeCodecsOnStartup: false,
        codecsPath: '/workers/cornerstoneWADOImageLoaderCodecs.min.js',
        usePDFJS: false,
        strict: false,
      },
    },
  };

  //// Deshabilitamos esta funcionalidad hasta que veamos que sea necesaria y podamos investigar a fondo acerca de los workers y los decoders
  // cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
}
